module.exports = __webpack_public_path__ + "static/restaurant_dbk01-a519efc05b65da7bcd13bf3b35d8a969.jpg";